<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar matDialogTitle class="mat-accent m-0" cdkDragHandle>
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{ 'workflows.screens.avvNotice.dialogTitle' | translate }}</span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content fusePerfectScrollbar>

        <h2>{{ 'workflows.screens.avvNotice.heading' | translate }}</h2>

        <p>
            {{ 'workflows.screens.avvNotice.bodyP1Prefix' | translate }}
            <ng-container *ngIf="tenant?.name"> {{ 'workflows.screens.avvNotice.bodyP1For' | translate }} <strong>{{ tenant.name }}</strong></ng-container>
            {{ 'workflows.screens.avvNotice.bodyP1Suffix' | translate }}
        </p>

        <p>{{ 'workflows.screens.avvNotice.bodyP2' | translate }}</p>

        <p [innerHTML]="'workflows.screens.avvNotice.bodyP3Html' | translate"></p>

    </div>

    <div mat-dialog-actions class="m-0 p-8 p-sm-16" fxLayout="row" fxLayoutAlign="end center">
        <button data-test="B-Verstanden" type="button" mat-flat-button color="accent" (click)="onClickClose()">
            {{ 'workflows.screens.avvNotice.confirmButton' | translate }}
        </button>
    </div>
</div>
